import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import {
  CRUDLayout,
  Alert,
  DataStatus,
  ActionButton,
  ReadButton,
  UpdateButton,
  InputSearch,
  Pagination,
  Table,
  THead,
  TBody,
  Tr,
  ThFixed,
  TdFixed,
  Th,
  Td,
  Checkbox,
  ApprovalStatusButton,
} from "components";
import { DateConvert, PageNumber as TableNumber } from "utilities";
import { PPAApi } from "api";
import { getStatusApprovalLabel } from "pages/Approval/ApprovalProgram/functions";

const HistoryApprovalPPA = () => {
  const history = useHistory();
  const location = useLocation();
  const [isPageLoading, setIsPageLoading] = useState(true);
  const [dataPPA, setDataPPA] = useState([]);
  const [paginationConfig, setPaginationConfig] = useState({
    page: "1",
    dataLength: "10",
    totalPage: "1",
    dataCount: "0",
  });
  const [searchConfig, setSearchConfig] = useState({
    status: false,
    key: "",
  });
  const [alertConfig, setAlertConfig] = useState({
    show: false,
    variant: "primary",
    text: "",
  });
  const [searchTime, setSearchTime] = useState(null);

  const getInitialData = () => {
    setIsPageLoading(true);

    PPAApi.getHistory({
      q: searchConfig.key,
      page: paginationConfig.page,
      per_page: paginationConfig.dataLength,
    })
      .then(({ data }) => {
        console.log("data", data);
        setDataPPA(data?.data ?? []);
        setPaginationConfig({
          ...paginationConfig,
          dataCount: data.data_count,
          totalPage: data.total_page,
        });
        // searchConfig.status &&
        //     setAlertConfig({
        //         show: true,
        //         variant: "primary",
        //         text: `Hasil dari pencarian: ${searchConfig.key}`,
        //     });
      })
      .catch((err) => {
        setAlertConfig({
          show: true,
          variant: "danger",
          text: "Data gagal dimuat!",
        });
      })
      .finally(() => setIsPageLoading(false));
  };

  const onInputSearchChange = (e) => {
    const key = e.target.value;
    if (searchTime) clearTimeout(searchTime);
    setSearchTime(
      setTimeout(() => {
        setSearchConfig({
          ...searchConfig,
          key: e.target.value,
        });
        setAlertConfig({
          show: key ? true : false,
          variant: "primary",
          text: "Hasil dari pencarian: " + key,
        });
      }, 750)
    );
  };

  const checkAlert = () => {
    const locationState = location.state;

    if (locationState) {
      if (locationState.alert) {
        setAlertConfig({
          show: locationState.alert.show,
          text: locationState.alert.text,
          variant: locationState.alert.variant,
        });
      }
    }
  };

  useEffect(() => {
    getInitialData();
    checkAlert();

    return () => {
      setIsPageLoading(false);
    };
  }, [searchConfig.key, paginationConfig.page, paginationConfig.dataLength]);

  const PageContent = () => {
    const DataTable = () => (
      <Table>
        <THead>
          <Tr>
            <ThFixed>No</ThFixed>
            <Th>Informasi Pembuat Pengajuan</Th>
            <ThFixed>Informasi PPA</ThFixed>
            <ThFixed>Informasi Sub Kegiatan</ThFixed>
            <ThFixed>Informasi Kegiatan</ThFixed>
            <ThFixed>Informasi Program</ThFixed>
            <Th>Program</Th>
            <Th>Nama Kegiatan</Th>
            <Th>Nama Sub Kegiatan</Th>
            <ThFixed>Status Approval</ThFixed>
            <Th style={{ width: "8.5rem" }}>Detail Pengajuan</Th>
          </Tr>
        </THead>
        <TBody>
          {dataPPA.map((val, index) => (
            <Tr key={index}>
              <TdFixed>
                {TableNumber(
                  paginationConfig.page,
                  paginationConfig.dataLength,
                  index
                )}
              </TdFixed>
              <Td>
                <div className="text-nowrap">
                  {val.nama_karyawan_pengaju ? val.nama_karyawan_pengaju : "-"}
                </div>
                <div className="text-nowrap">
                  {val.nama_jabatan_pengaju ? val.nama_jabatan_pengaju : "-"}
                </div>
              </Td>
              <Td>
                <div>
                  {val.tgl_ppa
                    ? DateConvert(new Date(val.tgl_ppa)).custom
                    : "-"}
                </div>
                <div>{val.no_ppa ?? "-"}</div>
              </Td>
              <Td>
                <div>
                  {val.tgl_sub_kegiatan
                    ? DateConvert(new Date(val.tgl_sub_kegiatan)).custom
                    : "-"}
                </div>
                <div>{val.no_sub_kegiatan ?? "-"}</div>
              </Td>
              <Td>
                <div>
                  {val.tgl_kegiatan
                    ? DateConvert(new Date(val.tgl_kegiatan)).custom
                    : "-"}
                </div>
                <div>{val.no_kegiatan ?? "-"}</div>
              </Td>
              <Td>
                <div>
                  {val.tgl_program
                    ? DateConvert(new Date(val.tgl_program)).custom
                    : "-"}
                </div>
                <div>{val.no_program ?? "-"}</div>
              </Td>
              <Td>{val.nama_program ?? "-"}</Td>
              <Td>{val.nama_kegiatan ?? "-"}</Td>
              <Td>{val.nama_sub_kegiatan ?? "-"}</Td>
              <TdFixed>
                <ApprovalStatusButton
                  variant={getStatusApprovalLabel(val.status_approval).variant}
                >
                  {getStatusApprovalLabel(val.status_approval).label}
                </ApprovalStatusButton>
              </TdFixed>
              <Td>
                <div className="d-flex justify-content-center">
                  <ActionButton
                    size="sm"
                    text="Lihat Detail"
                    className="col"
                    onClick={() =>
                      history.push(
                        `/human-resource/approval/ppa/detail/${val.id_ppa}`,
                        {
                          no_ppa: val.no_ppa,
                          tab: "history",
                        }
                      )
                    }
                  />
                </div>
              </Td>
            </Tr>
          ))}
        </TBody>
      </Table>
    );

    return (
      <>
        <DataTable />
        {!searchConfig.status && (
          <Pagination
            dataLength={paginationConfig.dataLength}
            dataNumber={
              paginationConfig.page * paginationConfig.dataLength -
              paginationConfig.dataLength +
              1
            }
            dataPage={
              paginationConfig.dataCount < paginationConfig.dataLength
                ? paginationConfig.dataCount
                : paginationConfig.page * paginationConfig.dataLength
            }
            dataCount={paginationConfig.dataCount}
            currentPage={paginationConfig.page}
            totalPage={paginationConfig.totalPage}
            onPaginationChange={({ selected }) =>
              setPaginationConfig({
                ...paginationConfig,
                page: selected + 1,
              })
            }
            onDataLengthChange={(e) =>
              setPaginationConfig({
                ...paginationConfig,
                page: 1,
                dataLength: e.target.value,
              })
            }
          />
        )}
      </>
    );
  };

  return (
    <CRUDLayout>
      {/* head section */}
      <CRUDLayout.Head>
        <CRUDLayout.HeadSearchSection>
          <Row className="mb-2">
            <Col md={8}>
              <InputSearch
                placeholder="Cari RAE"
                // value={searchConfig.key}
                onChange={onInputSearchChange}
              />
            </Col>
          </Row>
        </CRUDLayout.HeadSearchSection>
        <CRUDLayout.HeadButtonSection></CRUDLayout.HeadButtonSection>
      </CRUDLayout.Head>

      {/* alert */}
      <Alert
        show={alertConfig.show}
        variant={alertConfig.variant}
        text={alertConfig.text}
        showCloseButton={true}
        onClose={() =>
          setAlertConfig({
            ...alertConfig,
            show: false,
          })
        }
      />

      {/* content */}
      {isPageLoading ? (
        <DataStatus loading={true} text="Memuat data . . ." />
      ) : dataPPA ? (
        dataPPA.length > 0 ? (
          <PageContent />
        ) : (
          <DataStatus text="Tidak ada data" />
        )
      ) : (
        <DataStatus text="Data gagal dimuat" />
      )}
    </CRUDLayout>
  );
};

export default HistoryApprovalPPA;
